<template>
  <div class="loginBgc">
    <logo-head :islink="islink"></logo-head>
    <Form ref="loginData" :model="loginData" :rules="ruleInline">
      <div class="landing">
        <div class="landingTitle">
          <p>{{$t('i.login.examinationLanding')}}</p>
        </div>
        <div class="inputItem">
          <div class="languageBox">
            <div class="language">
              <span>{{ $t("i.login.language")}}：</span>
            </div>
            <div class="language-select">
              <Select :placeholder="loginData.defaultLangLabel" @on-change="languageSwitching">
                <Option v-for="item in loginData.languageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </div>
          </div>
          <div class="typeCompanyBox">
            <div class="typeCompanyText">
              <span>{{$t('i.personalInformation.typeOfCompany')}}：</span>
            </div>
            <div class="companyType">
              <FormItem prop="company">
                <Select v-model="loginData.company" :title="loginData.company">
                  <Option v-for="(typeCompany,index) in typeCompanys"
                          :key="typeCompany.entry_code" :value="typeCompany.entry_code">{{ typeCompany.entry_name }}</Option>
                </Select>
              </FormItem>
            </div>
          </div>
        </div>

        <div class="inputItem">
          <div class="domainBox">
            <div class="domainText">
              <span>{{$t('i.personalInformation.domain')}}：</span>
            </div>
            <div class="domain">
              <FormItem prop="domain">
                <Select v-model="loginData.domain">
                  <Option v-for="(domain,index) in domains"
                          :key="domain.entry_code" :value="domain.entry_code">{{ domain.entry_name }}</Option>
                </Select>
              </FormItem>
            </div>
          </div>
        </div>

        <div class="inputItem">
          <div class="user-name">
            <span>{{ $t("i.login.username")}}：</span>
          </div>
          <div class="name-text">
            <FormItem prop="user">
              <i-input type="text" v-model="loginData.user" placeholder="Username">
                <Icon type="ios-person-outline" slot="prepend"></Icon>
              </i-input>
            </FormItem>
          </div>
        </div>

        <div class="inputItem">
          <div class="password">
            <span>{{ $t("i.login.password")}}：</span>
          </div>
          <div class="password-text">
            <FormItem prop="password">
              <i-input type="password" v-model="loginData.password" placeholder="Password">
                <Icon type="ios-lock-outline" slot="prepend"></Icon>
              </i-input>
            </FormItem>
          </div>
        </div>

        <div class="inputItem">
          <div class="verification-code">
            <span>{{ $t("i.login.verificationCode")}}：</span>
          </div>
          <div class="verification-code-text" style="width: 138px">
            <FormItem prop="captcha">
              <i-input type="text" v-model="loginData.captcha"></i-input>
            </FormItem>
          </div>
          <div class="verification-code-img">
            <img :src="verificationCodeURI"
                 v-on:click="verificationCodeURI  = Constants.serverURL+'/validateCode?_='+new Date().getTime();"
                 alt="验证码">
          </div>
        </div>

        <div class="inputItem">
          <div class="loginBtnBox">
            <FormItem>
              <Button type="primary" @click="handleSubmit('loginData')">{{$t('i.login.land')}}</Button>
              <Button type="primary" @click="toForgetPasswd" style="margin-left: 20px;">{{$t('i.login.forgetThePassword')}}</Button>
            </FormItem>
          </div>
        </div>
      </div>
    </Form>
    <div v-show="flag2" class="forgetPasswordPopup">
      <forget-password ref="forgetPasswd" @closeForgetPasswd="closeForgetPasswd"></forget-password>
    </div>
    <div v-show="flag" :closable="false" :mask-closable="false" class="changePasswordPopup">
      <change-password  :pwdQuestionList = "pwdQuestionList" @closeChangePasswd="closeChangePasswd"></change-password>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js/crypto-js'
  import ChangePassword from "../../changePassword/changePassword";
  import ForgetPassword from "../../forgetPassword/forgetPassword";
  import LogoHead from "../../../common/components/loginLogoHead";
  export default {
    name: "loginTwo",
    components:{
      LogoHead,
      ForgetPassword,
      ChangePassword
    },
    data () {
      return {
        cityList: [
          {
            value: 'New York',
            label: 'New York'
          },
          {
            value: 'London',
            label: 'London'
          },
          {
            value: 'Sydney',
            label: 'Sydney'
          },
          {
            value: 'Ottawa',
            label: 'Ottawa'
          },
          {
            value: 'Paris',
            label: 'Paris'
          },
          {
            value: 'Canberra',
            label: 'Canberra'
          }
        ],
        model1: '',
        pwdQuestionList:[],
        flag: false,
        flag2: false,
        typeCompanys:[],
        domains: [
          { entry_code: '', entry_name: ''}
        ],
        loginData: {
          company: '',
          domain: '',
          user: '',
          password: '',
          captcha:'',
          defaultLangValue: localStorage.getItem("defaultLangValue"),
          defaultLangLabel: localStorage.getItem("defaultLangLabel"),
          languageList: JSON.parse(localStorage.getItem("defaultLangList")),
        },
        islink: false,
        verificationCodeURI: this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login0",
        ruleInline: {
          company: [
            { required: true, message: this.$t('i.login.company'), trigger: 'change'}
          ],
          domain: [
            { required: true, message: this.$t('i.login.domain'), trigger: 'change'}
          ],
          user: [
            { required: true, message: this.$t('i.login.user_message'), trigger: 'blur' }
          ],
          captcha: [
            { required: true, message: this.$t('i.login.verificationCode_message'), trigger: 'blur' }
          ],
          password: [
            { required: true, message: this.$t('i.login.password_message'), trigger: 'blur' },
            { type: 'string', min: 8,message: this.$t('i.login.password_length_message'),  trigger: 'blur' }
          ]
        }
      }
    },
    // message: 'The password length cannot be less than 6 bits',
    methods: {
      async companyList(){
        const json = await this.RequestUtil.request("/companyList");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.typeCompanys = json.datas;
          }
        }
      },
      async getDomainList(){
        const json = await this.RequestUtil.request("/companyList?code=SSLY");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.domains = json.datas;
          }
        }
      },
      closeChangePasswd(val,isClose){
        this.flag = isClose == '1' ? true : false;
        this.verificationCodeURI = this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login3";
        this.loginData.password = '';
        this.loginData.captcha = '';
        this.$emit('setLoginCheck', val);
      },
      closeForgetPasswd(val){
        this.flag2 = val == '1' ? true : false;
        this.$emit('setLoginCheck', val);
      },
      async getPwdQuestion(){
        const json = await this.RequestUtil.request("/getPwdQuestion");
        if(json) {
          if (json.statusCode == this.Constants.statusCode.ok) {
            this.pwdQuestionList = json.datas;
          }
        }
      },
      handleSubmit (name) {
        this.$refs[name].validate(async (valid) => {
          if (valid) {
            let url = "/dialogLogin?username=" + this.loginData.user;
            url += "&password=" + CryptoJS.SHA256(this.loginData.password);
            url += "&captcha=" + this.loginData.captcha;
            url += "&company=" + this.loginData.company;
            const json = await this.RequestUtil.request(url);
            if(json) {
              if (json.statusCode == this.Constants.statusCode.ok) {
                localStorage.setItem("curJsSessionId",json.datas.curJsSessionId);
                localStorage.setItem("userInfo",JSON.stringify(json.datas));
                const isInitPasswd = json.datas.isInitPasswd;
                const passwdExpired = json.datas.passwdExpired;
                if(isInitPasswd == '1'){
                  this.getPwdQuestion()
                  this.flag = true;
                  this.$Message.warning({content: this.$t('i.login.isInitPasswd'),duration: 5});
                  return;
                }else if(passwdExpired == '1'){
                  this.getPwdQuestion()
                  const passwdExpired = json.datas.passwdExpired;
                  this.flag = true;
                  this.$Message.warning({content: this.$t('i.login.passwdExpired'),duration: 5});
                  return;
                }else{
                  localStorage.setItem('domain', this.loginData.domain)
                  // this.$emit('setLoginCheck', '1');
                  this.$router.push({name:'index'});
                }
              }else{
                this.verificationCodeURI = this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login2";
                localStorage.removeItem("userInfo");
              }
            }
          }
        })
      },
      toForgetPasswd(){
        this.flag2 = true;
        this.$refs.forgetPasswd.refreshCaptcha();
      },
      verificationCodeURIClick(){
        this.verificationCodeURI  = this.Constants.serverURL+'/validateCode?_='+Date.now()+"&t_=login1";
      },
      languageSwitching(value){
        this.$i18n.locale = value;
        localStorage.setItem("defaultLangValue",value);
        setTimeout(()=>{
          const langList = [
            {
              value: 'zh_CN',
              label: this.$t('i.login.language_zh')
            },
            {
              value: 'ja_JP',
              label: this.$t('i.login.language_ja')
            }
          ];
          this.loginData.languageList = langList;
          let defaultLangLabel = this.$t('i.login.language_zh');
          if(value == "ja_JP"){
            defaultLangLabel = this.$t('i.login.language_ja');
          }
          this.loginData.defaultLangLabel = defaultLangLabel;
          console.log("defaultLangLabel",defaultLangLabel);
          localStorage.setItem("defaultLangLabel",defaultLangLabel);
          localStorage.setItem("defaultLangList",JSON.stringify(langList));
        },300);
      },
    },
    mounted(){
      let defaultLangValue = localStorage.getItem("defaultLangValue");
      let defaultLangList = localStorage.getItem("defaultLangList");
      if(!defaultLangValue || defaultLangList == null){
        defaultLangValue = 'zh_CN';
        localStorage.setItem("defaultLangValue","zh_CN");
        localStorage.setItem("defaultLangLabel","中文");
        const langList = [
          {
            value: 'zh_CN',
            label: '中文'
          },
          {
            value: 'ja_JP',
            label: '日语'
          }
        ];
        localStorage.setItem("defaultLangList",JSON.stringify(langList));
      }
      this.$i18n.locale = defaultLangValue;
      this.loginData.defaultLangValue = localStorage.getItem("defaultLangValue");
      this.loginData.defaultLangLabel =  localStorage.getItem("defaultLangLabel");
      this.loginData.languageList = JSON.parse(localStorage.getItem("defaultLangList"));
      this.companyList();
      this.getDomainList();
    },
    activated(){
      this.loginData.password = ''
      this.loginData.captcha = ''
      this.verificationCodeURI = this.Constants.serverURL+'/validateCode?_=' + Date.now()+"&t_=login0",
      console.info("activated=====================================================")
    }
  }
</script>

<style scoped>
  .loginBgc{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .landing{
    width: 400px;
    height: 400px;
    border: 1px solid #000;
    border-radius: 10px;
    margin: 50px auto 0 auto;
    overflow: hidden;
  }

  .landingTitle{
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 60px;
  }
  .landingTitle p{
    font-size: 18px;
    color: #5f5f5f;
  }

  .inputItem{
    width: 100%;
    height: 32px;
    margin-bottom: 18px;
  }

  .languageBox{
    width: 42%;
    height: 32px;
    float: left;
  }
  .language{
    width: 100px;
    height: 32px;
    line-height: 32px;
    float: left;
    text-align: right;
  }
  .language-select {
    width: 65px;
    height: 32px;
    float: left;
  }
  .typeCompanyBox {
    width: 58%;
    height: 32px;
    float: left;
  }
  .typeCompanyText {
    width: 72px;
    height: 32px;
    float: left;
    line-height: 32px;
    text-align: right;
  }
  .domainBox {
    display: flex;
  }
  .domainText {
    height: 32px;
    line-height: 32px;
    text-align: right;
    width: 25%;
    text-align: right;
  }
  .domain {
    width: 60%;
  }
  .companyType{
    width: 100px;
    float: left;
  }


  .user-name,
  .password,
  .verification-code
  {
    width: 100px;
    height: 32px;
    float: left;
    line-height: 32px;
    text-align: right;
  }
  /*.ivu-form-item{*/
    /*margin-bottom: 0px!important;*/
  /*}*/

  .name-text,
  .password-text,
  .verification-code-text
  {
    width: 238px;
    float: left;
  }

  /*body .ivu-modal .ivu-select-dropdown{*/
    /*position: fixed !important;*/
  /*}*/

  .verification-code-img{
    float: left;
    margin-left: 8px;
    margin-top: 2px;
  }
  .verification-code-img img{
    width: 90px;
    height: 30px;
    border-radius: 5px;
    cursor: pointer;
  }
  .loginBtnBox{
    width: 400px;
    height: 32px;
    text-align: center;
    /*background-color: pink;*/
    margin: 40px auto;
  }
  .changePasswordPopup{
    position: absolute;
    z-index: 111;
  }
  .forgetPasswordPopup{
    position: absolute;
    z-index: 110;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/login.vue